export default __webpack_public_path__ + "static/media/white-cross.371920c9.svg";